

















































import {Component, Prop, Vue} from "vue-property-decorator";
import {AxiosError} from "axios";

@Component
export default class ErrorMessage extends Vue{

    @Prop() title!:string;
    @Prop() value!:AxiosError;

    get messages(){
        /*this.value.response.data.messages.forEach((m)=>{
            console.log(m.message);
        })*/
        if(this.value && this.value.response){
            return this.value.response.data.messages;
        }
        return null;
    }

    close(){
        delete this.value;
        this.$emit('input',null);
    }

}
